import { render, staticRenderFns } from "./InvestmentsFS.vue?vue&type=template&id=23caa5d6&scoped=true"
import script from "./InvestmentsFS.vue?vue&type=script&lang=ts"
export * from "./InvestmentsFS.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentsFS.vue?vue&type=style&index=0&id=23caa5d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23caa5d6",
  null
  
)

export default component.exports